import React from 'react'
import Svg from './Svg'
export const SvgWells = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 1c6.628 0 12 5.372 12 12 0 4.519-2.498 8.454-6.188 10.501H6.188A11.997 11.997 0 010 13C0 6.372 5.372 1 12 1zm6.795 18.796A9.547 9.547 0 0021.61 13H19.5v-1.5h1.993a9.508 9.508 0 00-.998-3H18V7h1.507a10.059 10.059 0 00-.712-.795A9.568 9.568 0 0015 3.866v1.633h-1.5V3.506a9.696 9.696 0 00-3 0v1.993H9V3.866A9.56 9.56 0 004.493 7h1.506v1.5H3.504a9.506 9.506 0 00-.997 3h1.992V13H2.39c0 2.567.999 4.981 2.814 6.796.252.251.514.486.787.705H10.5L11.357 8.5h1.285l.858 12.001h4.508a9.86 9.86 0 00.787-.705z" />
  </Svg>
))
SvgWells.isIcon = true
export default SvgWells
